import React, { PropTypes } from 'react';
import { Message as SuiMessage } from 'semantic-ui-react';

import Fading from '../fading/Fading';


const propTypes = {
  icon: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};


const Message = ({ icon, header, text }) => (
  <Fading>
    <div key="message" style={{ overflowY: 'hidden', clear: 'both' }}>
      <SuiMessage
        visible
        error
        attached="bottom"
        icon={icon}
        header={header}
        content={text}
      />
    </div>
  </Fading>
);

Message.propTypes = propTypes;
export default Message;



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/components/shared/message/Message.js
 **/